import { useQuery } from '@tanstack/react-query';

import Axios from 'axios';
import { queryClient } from 'QueryClientProvider';

const onGetProjectAcctDetailsByID = (ID) => Axios.get(`/projects/getdetailsforaccounting/${ID}`);

const useProjectAccountingDetails = (ID) => {
    return useQuery({
        queryKey: ['projectaccountingdetails', ID],
        queryFn: () => onGetProjectAcctDetailsByID(ID),
        staleTime: 10000,
        cacheTime: 10000,
        retry: false,
    });
};

const forceReloadProjectAccountingDetails = (ID) => {
    return queryClient.invalidateQueries({ queryKey: ['projectaccountingdetails', ID] });
};

export { useProjectAccountingDetails, forceReloadProjectAccountingDetails };
